module.exports = __webpack_public_path__ + "img/excluir.9919141c.svg";